import IrregularidadesRotas from './irregularidades/IrregularidadesRotas'
import FiscalizacoesRotas from './fiscalizacoes/FiscalizacoesRotas'

export default {
    path: 'gestaofiscalizacoes',
    name: 'GestaoFiscalizacoes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        IrregularidadesRotas,
        FiscalizacoesRotas

    ]
}
